module.exports = __webpack_public_path__ + "static/media/new_year.866cd889.png";